import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex sm:flex-row flex-column justify-content-between w-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header-left" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "mb-0" }, "Administrare"),
  /*#__PURE__*/_createElementVNode("h5", { class: "mt-0" }, "Medici")
], -1)
const _hoisted_3 = { class: "header-right" }
const _hoisted_4 = { class: "stat-div" }
const _hoisted_5 = { class: "app-inner-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_DoctorList = _resolveComponent("DoctorList")!
  const _component_GenericModal = _resolveComponent("GenericModal")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, null, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              class: "p-button-md",
              type: "button",
              label: "Adauga medic",
              icon: "pi pi-plus",
              onClick: $setup.handleOnClickOpenModal,
              outlined: ""
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_Toast),
        _createVNode(_component_DoctorList, { doctors: $setup.doctors }, null, 8, ["doctors"]),
        _createVNode(_component_GenericModal)
      ])
    ]),
    _: 1
  }))
}